(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/_block_message.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "message_type") == "success") {
output += "\n    ";
var t_1;
t_1 = "badge-correct";
frame.set("sprite", t_1, true);
if(frame.topLevel) {
context.setVariable("sprite", t_1);
}
if(frame.topLevel) {
context.addExport("sprite", t_1);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message_type") == "error") {
output += "\n    ";
var t_2;
t_2 = "message-error";
frame.set("sprite", t_2, true);
if(frame.topLevel) {
context.setVariable("sprite", t_2);
}
if(frame.topLevel) {
context.addExport("sprite", t_2);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message_type") == "warning") {
output += "\n    ";
var t_3;
t_3 = "message-warning";
frame.set("sprite", t_3, true);
if(frame.topLevel) {
context.setVariable("sprite", t_3);
}
if(frame.topLevel) {
context.addExport("sprite", t_3);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message_type") == "informational") {
output += "\n    ";
var t_4;
t_4 = "message-information";
frame.set("sprite", t_4, true);
if(frame.topLevel) {
context.setVariable("sprite", t_4);
}
if(frame.topLevel) {
context.addExport("sprite", t_4);
}
output += "\n";
;
}
;
}
;
}
;
}
output += "\n\n<div class=\"comet-block-message__icon-box\">\n    <svg class=\"comet-block-message__icon\" aria-hidden=\"true\" focusable=\"false\">\n        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 12, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#"])), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sprite"), env.opts.autoescape);
output += "\"></use>\n    </svg>\n</div>\n<div class=\"comet-block-message__content comet-long-form-text\">\n    <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message_text"), env.opts.autoescape);
output += "</p>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/_block_message", function(){});

